var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-container"},[_c('i',{staticClass:"iconfont",class:_vm.getIcon})])
}
var staticRenderFns = []

export { render, staticRenderFns }